import React from "react";
import "./FunderingTab.css";
import RadioBlocksExtended from "src/components/Input/RadioBlocksExtended/RadioBlocksExtended";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import SelectUnselectExtended from "src/components/SelectUnselectExtended/SelectUnselectExtended";

const FunderingTab: React.FC = () => {
  const {
    state,
    setDimensions,
    setRoofMaterial,
    setOptionsMaterial,
    configuration,
  } = useConfiguration();

  const handlePoer = (value: string) => {
    if (value !== state.optionsMaterial.poer)
      setOptionsMaterial({ ...state.optionsMaterial, poer: value });
  };

  const handleFundering = (value: string) => {
    if (value !== state.optionsMaterial.fundering)
      setOptionsMaterial({ ...state.optionsMaterial, fundering: value });
  };
  const poers = [
    {
      id: -1,
      name: "Geen",
      value: "empty",
      imageUrl: `${process.env.PUBLIC_URL}/images/empty.png`,
      price: 0,
      color: "transparent",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

      component: undefined,
    },
    {
      id: 0,
      name: "Poeren",
      value: "poer",
      imageUrl: `${process.env.PUBLIC_URL}/images/poer.jpg`,
      price: configuration.calculationService.getPoer("poer"),
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

      component: undefined,
    },
    {
      id: 1,
      name: "HWA Poeren",
      value: "hwapoer",
      imageUrl: `${process.env.PUBLIC_URL}/images/hwa_poer_2.png`,
      price: configuration.calculationService.getPoer("hwapoer"),
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

      component: undefined,
    },
  ];

  const funderings = [
    {
      id: -1,
      name: "Geen",
      value: "empty",
      imageUrl: `${process.env.PUBLIC_URL}/images/empty.png`,
      price: 0,
      color: "transparent",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

      component: undefined,
    },
    {
      id: 0,
      name: "Fundatiekoker",
      value: "fundatiekoker",
      price: configuration.calculationService.getFundering("fundering"),
      imageUrl: `${process.env.PUBLIC_URL}/images/Fundatiekoker_2.png`,
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

      component: undefined,
    },
    // {
    //   id: 1,
    //   name: "Fundatiekoker en poer",
    //   value: "fundatiekokerpoer",
    //   price: 0,
    //   imageUrl: `${process.env.PUBLIC_URL}/images/Fundatiekoker_and_poeren.jpg`,
    //   description:
    //     "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",

    //   component: undefined,
    // },
  ];

  const PoerComponent = () => {
    return (
      <RadioBlocksExtended
        blocks={poers}
        value={state.optionsMaterial.poer}
        onChange={handlePoer}
        className="inner_child"
      />
    );
  };

  const FunderingComponent = () => {
    return (
      <RadioBlocksExtended
        blocks={funderings}
        value={state.optionsMaterial.fundering}
        onChange={handleFundering}
        className="inner_child"
      />
    );
  };

  let doorcheck = false;

  window.CONF.house.walls.map((item) => {
    if (
      item.sections[0].type.startsWith("door") ||
      item.sections[0].type.startsWith("window")
    )
      doorcheck = true;
  });

  if (!doorcheck) handleFundering("empty");

  return (
    <div className="fundering-tab">
      <SelectUnselectExtended
        name="Poeren"
        imageUrl={
          poers.find((i) => i.value === state.optionsMaterial.poer)?.imageUrl ||
          ""
        }
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
        color="transparent"
        isSelected={
          state.optionsMaterial.poer === "poer" ||
          state.optionsMaterial.poer === "hwapoer"
        }
        onSelect={
          // () =>
          // setOptionsMaterial({
          //   ...state.optionsMaterial,
          //   poer: "poer",
          // })
          () => true
        }
        onUnselect={
          // () =>
          // setOptionsMaterial({
          //   ...state.optionsMaterial,
          //   poer: "",
          // })
          () => false
        }
        // componentIsVisible={state.lights.enabled}
        Component={PoerComponent}
        selectedNames={
          poers.find((i) => i.value === state.optionsMaterial.poer)?.name || ""
        }
      />
      {doorcheck && (
        <SelectUnselectExtended
          name="Fundatiekoker"
          imageUrl={
            funderings.find((i) => i.value === state.optionsMaterial.fundering)
              ?.imageUrl || ""
          }
          color="transparent"
          description="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
          isSelected={
            state.optionsMaterial.fundering === "fundatiekoker" ||
            state.optionsMaterial.fundering === "fundatiekokerpoer"
          }
          onSelect={() =>
            // setOptionsMaterial({
            //   ...state.optionsMaterial,
            //   fundering: "fundatiekoker",
            // })
            () =>
              true}
          onUnselect={
            // () =>
            // setOptionsMaterial({
            //   ...state.optionsMaterial,
            //   fundering: "",
            // })
            () => false
          }
          // componentIsVisible={state.lights.enabled}
          Component={FunderingComponent}
          selectedNames={
            funderings.find((i) => i.value === state.optionsMaterial.fundering)
              ?.name || ""
          }
        />
      )}
    </div>
  );
};

export default FunderingTab;
